import type {
  CheckoutColors,
  ColorProperty,
  Colors,
  OffersPageColors,
} from '@trmediaab/zebra';
import { baseTheme } from '@trmediaab/zebra';
import { darken, tint } from 'polished';

const { colors: baseColors } = baseTheme;

const greyScale: ColorProperty[] = [
  '#E9E9E9', // 91% Brightness
  '#DDDDDD', // 87% Brightness
  '#999999', // 60% Brightness
  '#777777', // 47% Brightness
  '#222222', // 13% Brightness
];

const hexColors: Record<string, ColorProperty> = {
  red: '#D91E16',
  darkerRed: '#bd2415',
  blue: '#005CA0',
  grey95: '#F2F2F2',
  yellow: '#fceb85',
  orange: '#FF8300',
};

const primary = baseColors.brands.jokersystemet;
const textBase = greyScale[4];
const lightRed = tint(0.9, hexColors.red);
const border = greyScale[1];

const colors: Colors & CheckoutColors & OffersPageColors = {
  ...hexColors,
  greys: greyScale,

  primary,

  background: {
    primary: hexColors.grey95,
    trFooterLogoBox: greyScale[0],
  },

  text: {
    primary: textBase,
    faded: greyScale[2],
    fadedDarker: greyScale[3],
    highlight: hexColors.yellow,
  },

  link: {
    primary: hexColors.blue,
    active: darken(0.1, hexColors.blue),
  },

  divider: border,

  border: {
    primary: border,
  },

  quote: {
    text: primary,
    source: greyScale[3],
  },

  state: {
    success: primary,
    error: hexColors.red,
  },

  checkout: {
    containerBg: baseColors.white,
    containerBorder: border,

    discount: hexColors.red,

    cardBorder: hexColors.red,
    cardBgPrimary: 'transparent',
    cardBgSecondary: hexColors.grey95,
    cardHeaderText: baseColors.white,
    cardHeaderTextMuted: textBase,
    cardHeaderBg: hexColors.red,
    cardHeaderBgMuted: lightRed,

    infoBg: lightRed,

    selectIndicator: baseColors.white,
    selectIndicatorBg: hexColors.blue,

    progressText: greyScale[2],
    progressTextActive: textBase,
    progressNum: greyScale[2],
    progressNumBg: greyScale[1],
    progressNumActive: baseColors.white,
    progressNumBgActive: hexColors.red,

    checkboxSelected: hexColors.grey95,
    checkboxBgSelected: greyScale[2],

    icon1: hexColors.red,
    icon2: hexColors.orange,
    textInputIcon: greyScale[3],
    infoIcon: greyScale[3],

    verificationInputBg: baseColors.white,
    verificationInputText: textBase,
    verificationInputBorder: border,
  },

  offers: {
    backgroundPrimary: baseColors.white,
    backgroundComplementary: hexColors.grey95,
  },

  offersPage: {
    badge: {
      background: hexColors.blue,
      foreground: baseColors.white,
    },
    productBox: {
      border: border,
    },
  },

  landingPages: {
    lightHeader: {
      bg: greyScale[0],
      headingColor: textBase,
      preambleColor: textBase,
    },
    darkHeader: {
      bg: greyScale[3],
      headingColor: baseColors.white,
      preambleColor: baseColors.white,
    },
    brandHeader: {
      bg: primary,
      headingColor: baseColors.white,
      preambleColor: baseColors.white,
    },
  },
};

export default colors;
